<template>
  <div
    id="privilege-information-issue-limit"
    class="form-custom"
  >
    <b-row class="issue-limit-form">
      <b-col cols="12">
        <b-card
          no-body
          class="mb-1 pb-2"
        >
          <b-card-header>
            <span class="information-header">Issue - Limit</span>
          </b-card-header>
          <div class="row px-5">
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="row">
                    <div class="col col-md-6">
                      <b-form-group
                        :label="'Issue - Overall'"
                        label-for="'issue-overall"
                        class=""
                      >
                        <b-form-input
                          id="issue-overall"
                          v-model="formData.IssueOverall"
                          @input="
                            $emit('onNumberInput', $event, 'IssueOverall')
                          "
                        />
                      </b-form-group>
                    </div>
                    <div class="col col-md-6">
                      <b-form-group
                        :label="'Issue - per Day'"
                        label-for="'issue-per-day"
                        class=""
                      >
                        <b-form-input
                          id="issue-per-day"
                          v-model="formData.IssuePerDay"
                          @input="$emit('onNumberInput', $event, 'IssuePerDay')"
                        />
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <b-form-group
                        :label="'Issue - per Month'"
                        label-for="'issue-per-month"
                        class=""
                      >
                        <b-form-input
                          id="issue-per-month"
                          v-model="formData.IssuePerMonth"
                          @input="
                            $emit('onNumberInput', $event, 'IssuePerMonth')
                          "
                        />
                      </b-form-group>
                    </div>
                    <div class="col col-md-6">
                      <b-form-group
                        :label="'Issue - per Customer'"
                        label-for="'issue-per-customer"
                        class=""
                      >
                        <b-form-input
                          id="issue-per-customer"
                          v-model="formData.IssuePerCustomer"
                          @input="
                            $emit('onNumberInput', $event, 'IssuePerCustomer')
                          "
                        />
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <b-form-group
                        :label="'Issue - per Customer / Day'"
                        label-for="'issue-per-customer-day"
                        class=""
                      >
                        <b-form-input
                          id="issue-per-customer-day"
                          v-model="formData.IssuePerCustomerDay"
                          @input="
                            $emit(
                              'onNumberInput',
                              $event,
                              'IssuePerCustomerDay',
                            )
                          "
                        />
                      </b-form-group>
                    </div>
                    <div class="col col-md-6">
                      <b-form-group
                        :label="'Issue - per Customer / Month'"
                        label-for="'issue-per-ustomer-month"
                        class=""
                      >
                        <b-form-input
                          id="issue-per-ustomer-month"
                          v-model="formData.IssuePerCustomerMonth"
                          @input="
                            $emit(
                              'onNumberInput',
                              $event,
                              'IssuePerCustomerMonth',
                            )
                          "
                        />
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: { formData: { type: Object, default: {} } },
  setup() {
    return {}
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/privilege/privilege-information.css';
</style>
